import { setActiveBusiness } from "../services/businessProfileService";
import {
  syncActiveBusinessContext,
  updateActiveBusinessIdInCache,
} from "../hooks/query/businessProfiles";
import { queryClient } from "../queryClient";

export async function ensurePersonalWalletOnLogin(): Promise<void> {
  updateActiveBusinessIdInCache(queryClient, null);

  try {
    const payload = await setActiveBusiness({ businessId: null });
    await syncActiveBusinessContext(
      queryClient,
      payload?.activeBusinessId ?? null
    );
  } catch (error) {
    console.warn(
      "Failed to reset active business on login:",
      error instanceof Error ? error.message : String(error)
    );

    try {
      await syncActiveBusinessContext(queryClient, null);
    } catch (syncError) {
      console.warn(
        "Failed to sync personal business context after login reset:",
        syncError instanceof Error ? syncError.message : String(syncError)
      );
    }
  }
}
